import { useContext, useEffect, useState } from 'react';
import { Context as AuthContext } from '../contexts/AuthContext';
import FranchiseeService from '../services/Franchisee';

export function useFranchiseeTrelloIntegration() {
  const { token, currentFranchisee, currentSchool }: any = useContext(AuthContext);
  const [isTrelloActive, setIsTrelloActive] = useState(false);
  const [integrationChecked, setIntegrationChecked] = useState(false);

  useEffect(() => {
    const franchiseeId = currentFranchisee?.value || currentSchool?.franchiseeId;
    if (!token || !franchiseeId) {
      setIsTrelloActive(false);
      setIntegrationChecked(true);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const integrationResult = await FranchiseeService(token).getIntegration(franchiseeId);
        const integration = integrationResult?.data ?? integrationResult;
        if (!cancelled) {
          setIsTrelloActive(integration?.type === 'trello');
          setIntegrationChecked(true);
        }
      } catch {
        if (!cancelled) {
          setIsTrelloActive(false);
          setIntegrationChecked(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token, currentFranchisee?.value, currentSchool?.franchiseeId]);

  return { isTrelloActive, integrationChecked };
}
